import { customerServerApiClient } from "utils/apiClient";

export const openOrderApi = {
  async openOrder(data: any) {
    const res = await customerServerApiClient.post('nuvei/open-order', data);
    const resBody = res.data;
    return resBody;
  },
};
